export default {
  title: 'Feedback · {stage}',
  reportVersion: 'Versión del reporte',
  latest: 'última',
  feedbackOn: 'Feedback sobre {stage}',
  hint: 'Aún no hay mensajes. Escribe tus comentarios mientras recorres el reporte; el equipo de NG los responderá aquí.',
  downloadDeliverable: 'Descargar {name}',
  you: 'Tú',
  staff: 'Equipo de NG',
  onReport: 'Escrito sobre el reporte v{version} · haz click para mostrarlo',
  edit: 'Editar',
  delete: 'Eliminar',
  edited: 'Editado el {date}',
  deleted: 'Mensaje eliminado por {name} · {date}',
  deleteConfirm: '¿Eliminar este mensaje? Todos verán que lo eliminaste.',
  placeholder: 'Escribe un mensaje…',
  sendHint: '⌘/Ctrl + Enter para enviar',
  cancel: 'Cancelar',
  send: 'Enviar',
  save: 'Guardar',
  discardConfirm: '¿Descartar el mensaje sin enviar?',
  errorSaving: 'No se pudo guardar el mensaje. Inténtalo de nuevo.',
  errorDeleting: 'No se pudo eliminar el mensaje. Inténtalo de nuevo.',
  dividerHint: 'Arrastra para cambiar el ancho · haz click para ocultar el feedback',
  showFeedback: 'Mostrar feedback',
  feedbackTab: 'Feedback'
}
